import React, {useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { useAxios } from '../../../AxiosHandler';

import styles from './Fileupload.module.scss';
import ContentCard from "../../Shared/ContentCard/ContentCard";
import { useTranslate } from "react-polyglot";
import Header from "../../Shared/Header/Header";
import FileRequestList from "../../Shared/FileRequestList/FileRequestList";
import Footer from "../../Shared/Footer/Footer";

function Fileupload() {
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();

    // get form id from url
    const guid = window.location.pathname.split("/")[2];

    const [loading, setLoading] = useState<boolean>(true);
    const [notFound, setNotFound] = useState<boolean>(false);
    const [closeFile, setCloseFile] = useState<number>(0);

    const [formdata, setFormdata] = useState<any>({});
    
    const [files, setFiles] = useState<Array<any>>([]);

    function getForminfo() {
        axios.single({
            url: '/api/fileupload/' + guid,
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res: any) => {
            setLoading(false);
            setFormdata(res.data);
            setFiles(res.data.documentdefinitions.map((f: any) => {
                return {
                    name: f.name,
                    filename: f.filename,
                    data: f.uploaded ? {
                        filename: f.filename,
                        filetype: f.type,
                    } : undefined,
                    fileCode: f.code,
                    status: f.uploaded ? "received" : "requested",
                    helptitle: f.name,
                    helpdescription: "Her kan du laste opp " + f.name + ". Klikk på knappen under for å laste opp filen. Du kan også dra filen inn i feltet.",
                };
            }));
        }).catch((err: any) => {
            console.log(err);
            setNotFound(true);
            setLoading(false);
        });
        
        if (guid == "test") {
            setFormdata({
                caseid: "321123",
            });
            setFiles([
                {
                    name: "Vognkort del 1",
                    data: {
                        filename: "vognkortdel1.jpg",
                        filetype: "image/jpeg",
                    },
                    fileCode: 123,
                    status: "received",
                    helptitle: "Opplasting",
                    helpdescription: "Her kan du laste opp vogntkort del 1. Klikk på knappen under for å laste opp filen. Du kan også dra filen inn i feltet.",
                },
                {
                    name: "Vognkort del 2",
                    data: undefined,
                    fileCode: 124,
                    status: "requested",
                    helptitle: "Opplasting",
                    helpdescription: "Her kan du laste opp vogntkort del 2. Klikk på knappen under for å laste opp filen. Du kan også dra filen inn i feltet.",
                },
                {
                    name: "Finansieringsbevis",
                    data: undefined,
                    fileCode: 125,
                    status: "requested",
                    helptitle: "Opplasting",
                    helpdescription: "Her kan du laste opp finansieringsbevis. Klikk på knappen under for å laste opp filen. Du kan også dra filen inn i feltet.",
                },
                {
                    name: "Kjøpekontrakt",
                    data: undefined,
                    fileCode: 126,
                    status: "requested",
                    helptitle: "Opplasting",
                    helpdescription: "Her kan du laste opp kjøpekontrakt. Klikk på knappen under for å laste opp filen. Du kan også dra filen inn i feltet.",
                }
            ]);
        }
    }

    async function getBase64(file: any) {
        let promise = new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
                console.log('Error: ', error);
            };
        });
        return promise;
     }

    async function sendFile(file: any, fileSource: any) {
        let promise = new Promise((resolve, reject) => {
            toast.info("Sender fil ..", { autoClose: false });
            getBase64(file).then((filedata: any) => {
                axios.single({
                    url: '/api/fileupload/',
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: {
                        key: guid,
                        documentdefinitioncode: fileSource.fileCode,
                        filename: file.name,
                        filedata: filedata.split(",")[1],
                    }
                }).then((res: any) => {
                    toast.dismiss();
                    if (res.status == 200) {
                        resolve(res.data);
                        toast.success("Fil sendt.");
                    }
                }).catch((err: any) => {
                    toast.dismiss();
                    console.log(err);
                    toast.error("Noe gikk galt, prøv igjen.");
                    reject(err);
                });
            }).catch((err: any) => {
                toast.dismiss();
                console.log(err);
                toast.error("Noe gikk galt, prøv igjen.");
                reject(err);
            });
        });
        return promise;
    }

    useEffect(() => {
        if (guid != undefined) {
            getForminfo();
        }
    }, [guid]);

    return (<>
        <Header />
        <div className={styles.content}>
            { !loading ? 
                <div className={styles.fileupload}>
                    { !notFound || guid == "test" ?
                        <>
                            <ContentCard open={true} disableClick={true}>
                                { guid == "test" ?
                                    <span style={{
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        padding: "2px 20px",
                                    }}>
                                        <h1 style={{color: "red"}}>TESTING</h1>
                                    </span>
                                : null }
                                <h1>{t("fileupload.title")}: { formdata.caseid }</h1>
                                <p>{t("fileupload.description")}</p>
                                { files.length > 0 ?
                                    <FileRequestList
                                        title={t("fileupload.documentsinput.title")}
                                        description={t("fileupload.documentsinput.description")}
                                        files={files}
                                        closeFile={closeFile}
                                        onFileChange={( index: number, file: any) => {}}
                                        uploadHandler={(index: number, file: any, fileSource: any) => {
                                            sendFile(file, fileSource).then(() => {
                                                // Set status to received at index
                                                let newFiles: Array<any> = [...files];
                                                newFiles[index].status = "received";
                                                newFiles[index].data = {
                                                    filename: file.name,
                                                    filetype: file.type,
                                                };
                                                setFiles(newFiles);

                                                setCloseFile(closeFile + 1);
                                            }).catch((err) => {
                                                console.log(err);
                                            });
                                        }}
                                    ></FileRequestList>
                                :
                                    <div className="ffe-small-text" style={{ marginBottom: "6px" }}>
                                        <hr/>
                                        <span style={{color: "red"}}>{ t("fileupload.nofiles") }</span>
                                    </div>
                                }
                                { formdata.caseid == undefined ?
                                    <div className="ffe-small-text" style={{ marginBottom: "6px" }}>
                                        <hr/>
                                        <span style={{color: "red"}}>{ t("fileupload.nocaseid") }</span>
                                    </div>
                                : null }
                            </ContentCard>
                            { files.length > 0 && files.every((file) => file.status == "received") ?
                                <ContentCard 
                                    title={t("fileupload.completed.title")}
                                    open={true} 
                                    disableClick={true}
                                >
                                    <p style={{ textAlign: "center" }}>{t("fileupload.completed.description")}</p>
                                </ContentCard>
                            : null }
                        </>
                    :
                        <div className={styles.notfound}>
                            <ContentCard open={true} disableClick={true}>
                                <p><strong>{t("fileupload.errorpage.schema_not_found_warning")}</strong></p>
                                <p>{t("fileupload.errorpage.schema_not_found")}</p>
                            </ContentCard>
                        </div>
                    }
                </div>
            :
                <div className={styles.loading}>
                    <p>Laster inn skjema ..</p>
                </div>
            }
        </div>
        <Footer />
    </>);
};


export default Fileupload;